import { useOidcStore } from "vue3-oidc";
import {
  Configuration as AuditPppBackConfiguration,
  ActionPlanApi,
  AuditApi,
  MissionApi,
  ReportApi,
  ResponseError,
  TaskResultApi,
  UserApi,
} from "@socotec.io/audit-ppp-back-sdk";
import { Configuration } from "@socotec.io/document-sdk";
import {
  Configuration as UserManagementConfiguration,
  AgenciesApi,
  UsersApi,
} from "@socotec.io/user-management-sdk";

const tokenGetter = () => {
  return useOidcStore().state.value.token;
};

const bearerTokenGetter = () => `Bearer ${useOidcStore().state.value.token}`;

// The SDK error message does not give the status code: keep the one axios used to give.
const statusCodeErrorMiddleware = {
  post: async ({ response }) => {
    if (response.status < 200 || response.status >= 300) {
      throw new ResponseError(response, `Request failed with status code ${response.status}`);
    }
    return response;
  },
};

const auditPppBackConfig = new AuditPppBackConfiguration({
  basePath: import.meta.env.VITE_APP_BACK_URL,
  accessToken: tokenGetter,
  middleware: [statusCodeErrorMiddleware],
});

const documentConfig = new Configuration({
  basePath: import.meta.env.VITE_APP_DOCUMENT_REST_API_URL,
  accessToken: tokenGetter,
});

const userManagementConfig = new UserManagementConfiguration({
  basePath: import.meta.env.VITE_APP_USER_MANAGEMENT_REST_API_URL,
  accessToken: bearerTokenGetter,
});

// Centralized audit-ppp-back REST API instances
const actionPlanApi = new ActionPlanApi(auditPppBackConfig);
const auditApi = new AuditApi(auditPppBackConfig);
const missionApi = new MissionApi(auditPppBackConfig);
const reportApi = new ReportApi(auditPppBackConfig);
const taskResultApi = new TaskResultApi(auditPppBackConfig);
const userApi = new UserApi(auditPppBackConfig);

// Centralized user-management REST API instances
const agenciesApi = new AgenciesApi(userManagementConfig);
const usersApi = new UsersApi(userManagementConfig);

export {
  documentConfig,
  userManagementConfig,
  agenciesApi,
  usersApi,
  actionPlanApi,
  auditApi,
  missionApi,
  reportApi,
  taskResultApi,
  userApi,
};
